<template>
  <div class="culture">
    <div class="banner"></div>
    <div class="culturecontent">
      <div class="navs">
        <navlist :navlist="navlist" @returnpath="returnpath" />
      </div>
      <div class="miancontent">
        <joinusdy v-if="navindex == 0" @sendnewsinfo="sendnewsinfo" />
        <juinuscenter v-if="navindex == 1" />
      </div>
    </div>
  </div>
</template>

<script>
import navlist from "./commonnavs.vue";
import joinusdy from "./joinusdy.vue";
import juinuscenter from "./juinuscenter.vue";
export default {
  components: { navlist, joinusdy, juinuscenter },
  data() {
    return {
      navlist: {
        name: "人才发展",
        list: [
          { name: "培训动态", index: 0 },
          { name: "招聘中心", index: 1 },
        ],
      },
      navindex: 0,
      issend: 0,
    };
  },
  methods: {
    returnpath(e) {
      if (e == 0) {
        this.navindex = e;
      } else {
        window.open("https://mp.weixin.qq.com/s/ahQLGgglIriQykGYfVjvQA");
      }
    },
    sendnewsinfo(e) {
      this.$router.push({
        path: "/news/info",
        query: e,
      });
    },
  },
};
</script>

<style scoped lang="less">
.culture {
  .culturecontent {
    .miancontent {
      flex: 1;
    }
    .navs {
      width: 10.42vw;
      height: 21.88vw;
      margin-right: 1.25vw;
    }
    width: 100%;
    padding: 2.0833vw 13.54vw;
    display: flex;
  }
  .banner {
    width: 100%;
    height: 26.04vw;
    //background: url("https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/banner/bannerjoinustop.png") no-repeat;
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/bannerjoinustop.png") no-repeat;
    background-position: 0 0;
    background-size: 100%;
  }
  width: 100%;
  background: rgba(240, 242, 246, 1);
  position: relative;
}
</style>
